import React from "react";
import { Market } from "../../components/market/market.component";

export const MarketPage = () => {
  return <Market />;
};
